module.exports = __webpack_public_path__ + "static/Psycho-Active-Logo-tshirt-Web-Transparent-a3f8f62ba288f4558b8c922e33687c39.png";